export interface IMessage {
    role: RoleType,
    content: string | IChatResponse
}

export type RoleType = 'user' | 'assistant' | 'system'


export interface IChatResponse {
    data: Array<any>,
    keys: Array<string>
    query: Object
}

export interface IChatOption {
    name: string,
    label: string,
    checked: boolean,
    type: "button" | "radio"
    radioOptions?: Array<{label: string, value: string}>
}

export enum ChatTypeEnum {
    QNA = "q&a",
    QUERY = "query"
}
